// this is the new constants.js file, but with typescript-syntax support enabled

import { ISupportBannerConfig } from "./models/interfaces/ISupportBannerComponent";
import { ComponentNamesKeys, PathNamesKeys } from "../pages/deliveryIssues/models/types/ComponentNamesType";
import { useTags } from "./composables/useTags";

export const SAFE_TEXT_REGEXP = /^[a-zA-Z0-9 '.-]+$/;
export const FULL_SAFE_TEXT_REGEXP = /^[a-zA-Z0-9 '.?,"()&\n\r-]+$/;
export const SAFE_STRING_WITH_PUNCTUATION = /[\p{L}\p{M}\p{N}\p{Pd}\p{Pi}\p{Pf}\p{Pc}\p{Po}\p{Sc}\p{So}\p{Cf}\p{Z}=()~Z-az-~+]+$/gum;
export const EMAIL_REGEXP = /^[ A-Za-z0-9+._% '-]+@[A-Za-z0-9.-]+\.[a-zA-Z ]{2,}$/;
export const ORDER_NUMBER_REGEXP = /^([a-zA-Z][0-9]+)$/;
export const URLS = /((http|https):\/\/)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?/i;

export const OTHER_TYPE_MAXLENGTH = 2000;
export const backgroundColor = 'primary';
export const emailResponseTimeDefaultVal = '24 hours';
export const emailResponseTimePlaceholder = '{responseTimeText}';

export const pathNames: Record<PathNamesKeys, string> = {
  INITIAL_PATH: 'INITIAL_PATH',
  UNSURE_ORDER_STATUS: 'Unsure of order status',
  TRACKING_SHOW_BUT_NOT_HERE: 'Tracking shows delivered but it\'s not here',
  TRACKING_SHOW_BUT_NOT_HERE_USER_DATA: 'TRACKING_SHOW_BUT_NOT_HERE_USER_DATA',
  LOST_ORDER: 'Lost order',
  LOST_ORDER_USER_DATA: 'LOST_ORDER_USER_DATA',
  HOW_CAN_HELP: 'HOW_CAN_HELP',
  MISSING_ITEM: 'Missing item',
  MISSING_ITEM_USER_DATA: 'MISSING_ITEM_USER_DATA',
  INCORRECT_ITEM: 'Received incorrect item',
  INCORRECT_ITEM_USER_DATA: 'INCORRECT_ITEM_USER_DATA',
  RECEIVED_DAMAGED: 'Damaged item',
  SOMETHING_ELSE: 'Something else',
  REQUEST_SEND: 'REQUEST_SEND',
};

export const componentNames: Record<ComponentNamesKeys, string> = {
  HELP_WITH_MY_ORDER: 'HELP_WITH_MY_ORDER',
  INFORMATION_PAGE: 'INFORMATION_PAGE',
  WRONG_ORDER_INFO: 'WRONG_ORDER_INFO',
  USER_DATA: 'USER_DATA',
  HOW_CAN_WE_HELP: 'HOW_CAN_WE_HELP',
  REQUEST_SEND: 'REQUEST_SEND',
};

export const defaultPathUrls: Record<string, string> = {
    DeliveryIssuesInitialPage: '/help/delivery-issues',
    PriceAdjustmentInitialPage: '/help/price-adjustment',
    PriceAdjustmentConfirmationPage: '/help/price-adjustment-confirmation',
    PriceAdjustmentDetailsPage: '/help/price-adjustment-details',
};

export const pathMapping: Record<string, string> = {
  'delivery-issues': componentNames.HELP_WITH_MY_ORDER,
  'delivery-issues-check': componentNames.INFORMATION_PAGE,
  'delivery-issues-details': componentNames.USER_DATA,
  'delivery-issues-shipping': componentNames.HOW_CAN_WE_HELP,
  'delivery-issues-confirmation': componentNames.REQUEST_SEND,
  'delivery-issues-order': componentNames.WRONG_ORDER_INFO,
};

export const bannerConfigsMap: Record<string, ISupportBannerConfig> = {
  loading: {
    type: 'info',
    initialText: 'Loading...',
  },
  success: {
    type: 'success',
    initialText: `We\'ll follow up by email within ${emailResponseTimePlaceholder}.`,
  },
  error: {
    type: 'error',
    initialText: 'Oops, something went wrong. Try again later or ',
    isButton: true,
    buttonText: 'chat with us',
    finalText: ' instead',
    analyticLinkName: useTags('getTag', 'DELIVERY_ISSUES'),
  },
};
